import { render, staticRenderFns } from "./buyer-menu.vue?vue&type=template&id=3fa3cd36&scoped=true&"
import script from "./buyer-menu.vue?vue&type=script&lang=js&"
export * from "./buyer-menu.vue?vue&type=script&lang=js&"
import style0 from "./buyer-menu.vue?vue&type=style&index=0&id=3fa3cd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3cd36",
  null
  
)

export default component.exports